export const minutesToMilliseconds = (minutes: number) => minutes * 60000

export const humanReadableDate = (date: string) => {
  // FROM: 2024-02-12T15:11:17.749Z
  // TO: 2019-11-02 12:37:34
  return date.replace('T', ' ').slice(0, -5)
}

export const formatDateDDMMYYYY = (date: string | Date) => {
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}
